import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PAST from '../events/REQUIRED_FIELDS_PAST';

export default function usePastEventsForUser(user, options = {}) {
  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          creatorId: user.id,
          $and: REQUIRED_FIELDS_PAST.$and
        }
      }
    },
    pagination: {
        page: options.page || 1,
        pageSize: options.pageSize || 3,
        order: 'createdAt desc'
      }
    });
  }
